<template>
	<div class="overlay-floating-panel" :style="{ left: `${px}px`, top: `${py}px`, width: `${width}px` }" @mousedown.stop @keydown.esc="$emit('close')">
		<div class="ofp-header" @mousedown="startDrag">
			<strong class="flex-fill">{{title}}</strong>
			<b-button variant="link" size="sm" class="p-0 text-body" @click="$emit('close')"><b-icon icon="x-lg" /></b-button>
		</div>
		<div class="ofp-body"><slot /></div>
	</div>
</template>

<script>
export default {
	props: {
		title: { type: String, default: '' },
		x: { type: Number, default: 100 },
		y: { type: Number, default: 100 },
		width: { type: Number, default: 280 },
	},
	data() { return { px: this.x, py: this.y, drag: null }},
	mounted() {
		this.px = Math.max(4, Math.min(this.px, window.innerWidth - this.width - 4));
		this.py = Math.max(4, Math.min(this.py, window.innerHeight - 120));
	},
	methods: {
		startDrag(e) {
			if(e.target.closest('button')) return;
			this.drag = { dx: e.clientX - this.px, dy: e.clientY - this.py };
			document.addEventListener('mousemove', this.onMove);
			document.addEventListener('mouseup', this.endDrag);
		},
		onMove(e) {
			if(!this.drag) return;
			this.px = e.clientX - this.drag.dx;
			this.py = e.clientY - this.drag.dy;
		},
		endDrag() {
			this.drag = null;
			document.removeEventListener('mousemove', this.onMove);
			document.removeEventListener('mouseup', this.endDrag);
		},
	},
	beforeDestroy() {
		this.endDrag();
	},
};
</script>

<style lang="scss" scoped>
@import '../../plugins/variable.scss';

.overlay-floating-panel {
	position: fixed;
	z-index: 1500;
	max-height: calc(100vh - 16px);
	display: flex;
	flex-direction: column;
	background: $gray-400;
	border: 1px solid $border-color;
	border-radius: .4rem;
	box-shadow: 0 8px 28px rgba(0, 0, 0, .55);
}

.ofp-header {
	display: flex;
	align-items: center;
	padding: .35rem .6rem;
	background: $gray-600;
	border-radius: .4rem .4rem 0 0;
	cursor: move;
	user-select: none;
}

.ofp-body {
	padding: .6rem;
	overflow-y: auto;
}
</style>
